const forgotPassword = {
  toastr: 'Link enviado por email',
  toastr1: 'Email enviado com sucesso'
};

export default forgotPassword;
